function checkLogin(url, returnUrl) {
    jQuery.ajax({
        url: url,
        dataType: 'json',
        xhrFields: { withCredentials: true },
        success: function (data) {
            if (data.isLogged === true) {
                $(location).attr("href", "/ingresar-sso?returnUrl=" + returnUrl);
            }
        }
    });

}